import axios from "axios";
import API_VERSION from "../data/api-version";

const ShopifyCreateCustomerAccessToken = async (email, password) => {
  try {
    const response = await axios({
      url: `https://${process.env.REACT_APP_SHOP_URL}/api/${API_VERSION}/graphql.json`,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": process.env.REACT_APP_SHOP_ACCESS_TOKEN,
      },
      data: {
        query: `mutation {
          customerAccessTokenCreate(input: {
            email: "${email}"
            password: "${password}"
          }) {
            customerUserErrors {
              code
              field
              message
            }
            customerAccessToken {
              accessToken
              expiresAt
            }
          }
        }`,
      },
    });
    if (response.data.data.customerAccessTokenCreate) {
      return response.data.data.customerAccessTokenCreate;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default ShopifyCreateCustomerAccessToken;
